import React from 'react';
import styled from 'styled-components';
import { connectCurrentRefinements } from 'react-instantsearch-dom';

const Wrapper = styled.div`
  margin-top: 10px;
  width: 100%;
`;

const CurrentRefinements = props => {
  const { items, refine } = props;

  const formatLabel = label => {
    if (label.includes('<=')) {
      return label.replace(/<=/g, '<');
    } else {
      return label;
    }
  };

  return (
    <Wrapper className="ais-CurrentRefinements">
      <ul className="ais-CurrentRefinements-list">
        {items.map(item => {
          return item.items ? (
            item.items.map((nested, i) => (
              <li
                key={nested.label + i}
                data-key={nested.label + i}
                className="ais-CurrentRefinements-item"
              >
                <span className="ais-CurrentRefinements-category">
                  <span className="ais-CurrentRefinements-categoryLabel">
                    {formatLabel(nested.label)}
                  </span>
                  <button
                    className="ais-CurrentRefinements-delete"
                    onClick={event => {
                      event.preventDefault();
                      refine(nested.value);
                    }}
                  >
                    ✕
                  </button>
                </span>
              </li>
            ))
          ) : (
            <li
              key={item.label}
              data-key={item.label}
              className="ais-CurrentRefinements-item"
            >
              <span className="ais-CurrentRefinements-category">
                <span className="ais-CurrentRefinements-categoryLabel">
                  {formatLabel(item.label)}
                </span>
                <button
                  className="ais-CurrentRefinements-delete"
                  onClick={event => {
                    event.preventDefault();
                    refine(item.value);
                  }}
                >
                  ✕
                </button>
              </span>
            </li>
          );
        })}
      </ul>
    </Wrapper>
  );
};

const CustomCurrentRefinements = connectCurrentRefinements(CurrentRefinements);

export default CustomCurrentRefinements;
